var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-checkbox-group',{attrs:{"options":_vm.options,"stacked":"","disabled":_vm.plaintext},on:{"change":_vm.checkChange},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})
}
var staticRenderFns = []

export { render, staticRenderFns }